import { Navigate } from '@sorare/routing';
import { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_SERIES_MY_CARDS_CARDS_TYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

export const CardsPage = () => {
  const { generateSportContextPath } = useSportContext();
  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_SERIES_MY_CARDS_CARDS_TYPE, {
        params: {
          type: Rarity.common,
        },
      })}
      replace
    />
  );
};

export default CardsPage;
